var surfaceBackgroundPropsSet = new Set(['base.surface', 'base.surface.floating', 'base.surface.floating.inverted', 'base.surface.inverted', 'base.transparent']);

export { surfaceBackgroundPropsSet };
//# sourceMappingURL=Container.type.js.map
